import React from 'react';
import { FaStar } from 'react-icons/fa';
import { DraggableComponents } from '../../../../../common/types/checkout';
import * as S from './styles';

type Props = {
  component: DraggableComponents;
};

export const AvatarSocialProof: React.FC<Props> = ({ component }) => {
  return (
    <S.TestimonialsGrid>
      <S.TestimonialCard>
        <S.TestimonialHeader>
          <S.Avatar
            src={component?.configurations?.testimonial?.avatar}
            alt={component?.configurations?.testimonial?.name}
          />
          <S.TestimonialInfo>
            <S.TestimonialName>
              {component?.configurations?.testimonial?.name}
            </S.TestimonialName>
            <S.StarsContainer>
              {[...Array(component?.configurations?.testimonial?.rating)].map(
                (_, i) => (
                  <S.Star key={i}>
                    <FaStar />
                  </S.Star>
                ),
              )}
            </S.StarsContainer>
          </S.TestimonialInfo>
        </S.TestimonialHeader>
        <S.TestimonialText>
          {component?.configurations?.testimonial?.text}
        </S.TestimonialText>
      </S.TestimonialCard>
    </S.TestimonialsGrid>
  );
};
